import { render, staticRenderFns } from "./salesCommissionScheme.vue?vue&type=template&id=584d4632"
import script from "./salesCommissionScheme.vue?vue&type=script&lang=js"
export * from "./salesCommissionScheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports